<template>
  <div class="text-center">
    <v-dialog persistent v-model="dialog" width="850">
      <v-card>
        <v-card-title
          class="d-flex justify-space-between headline purple accent-4 py-1"
        >
          <div class="subtitle-1 white--text">Volunteer Filter</div>
          <div>
            <v-btn @click="cancel" class="white--text" icon>
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col lg="8">
              <label>Search</label>
              <v-text-field
                type="text"
                v-model="search"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col>
              <v-btn
                class="mt-6 ml-2"
                @click="searchByText"
                color="teal accent-4"
                depressed
                dark
              >
                <v-icon left>mdi-magnify</v-icon>Search
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="3">
              <label>Training : Start Date</label>
              <date-picker
                @clearDate="startDate = null"
                :date="startDate"
                v-model="startDate"
              />
            </v-col>
            <v-col lg="3">
              <label>End Date</label>
              <date-picker
                @clearDate="endDate = null"
                :date="endDate"
                v-model="endDate"
              />
            </v-col>
            <v-col lg="3">
              <label>Training Type</label>
              <v-combobox
                v-model="type"
                placeholder="choose type"
                outlined
                dense
                item-text="name"
                item-value="id"
                :items="trainingTypes"
              ></v-combobox>
            </v-col>
            <v-col lg="3">
              <label>Way Of Training</label>
              <v-combobox
                v-model="way_of_training"
                placeholder="choose type"
                outlined
                dense
                item-text="name"
                item-value="id"
                :items="types"
              ></v-combobox>
            </v-col>
            <v-col lg="12" style="text-align: center">
              <v-btn
                @click="searchData"
                color="teal accent-4"
                depressed
                dark
                class="mb-1"
              >
                <v-icon left>mdi-magnify</v-icon>Search
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePicker from "@/components/common/DatePicker.vue";
export default {
  components: { DatePicker },
  props: {
    dialog: {
      type: Boolean,
    },
  },
  data: () => ({
    search: "",
    startDate: "",
    endDate: "",
    type: "",
    way_of_training: "",
    trainingTypes: [
      { id: 1, name: "On Job" },
      { id: 2, name: "New" },
      { id: 3, name: "Refersher" },
      { id: "", name: "" },
    ],
    types: [
      { id: 1, name: "In-person" },
      { id: 2, name: "Virtual" },
    ],
  }),
  computed: {},
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    searchByText() {
      this.$router.push(`/volunteer?search=${this.search}`);
      this.$emit("cancel");
      this.search = null;
    },
    searchData() {
      if (this.startDate && this.endDate) {
        var url = `/volunteer?startDate=${this.startDate}&endDate=${this.endDate}`;
        if (this.type && this.type.name.length > 0) {
          url += `&training_type_id=${this.type.id}`;
        }

        if (this.way_of_training && this.way_of_training.name.length > 0) {
          url += `&type=${this.way_of_training.id}`;
        }

        this.$router.push(url);
        this.$emit("cancel");
      }
    },
  },
};
</script>

<style scoped>
.detail p {
  font-size: 15px;
  margin-left: 10px;
  letter-spacing: 1px;
}
</style>
